import { compressToUTF16, decompressFromUTF16 } from 'lz-string';

/**
 * Compresses a JSON-serializable payload if it exceeds the byte threshold.
 */
export function compressData(
  payload: unknown,
  thresholdBytes: number,
): { data: string; compressed: boolean; originalSize: number } {
  const serialized = JSON.stringify(payload);
  const originalSize = new Blob([serialized]).size;

  if (originalSize <= thresholdBytes) {
    return { data: serialized, compressed: false, originalSize };
  }

  const compressed = compressToUTF16(serialized);
  return { data: compressed, compressed: true, originalSize };
}

/**
 * Decompresses data stored by compressData().
 */
export function decompressData<T>(data: string, isCompressed: boolean): T {
  if (!isCompressed) {
    return JSON.parse(data) as T;
  }

  const decompressed = decompressFromUTF16(data);
  if (!decompressed) {
    throw new Error('Failed to decompress cached data');
  }
  return JSON.parse(decompressed) as T;
}
